<template>
	<div class="text-center">
		<v-container>
			<div :class="['text-h6', 'pa-4']">
				{{ $t('titles.candidateManualRegistration') }}
			</div>
			<v-row>
				<v-col cols="12">
					<Dropdown
						v-model="candidateId"
						:ajax="true"
						:clearable="true"
						:data="'candidates'"
						:errorBorder="!candidateIdValidation"
						:label="'* ' + $t('fields.candidate')"
					></Dropdown>
				</v-col>
				<v-col cols="12" v-if="candidateId != null">
					<Dropdown3
						v-model="loginTypeId"
						:ajax="true"
						:data="'preregistration-login-types'"
						:errorBorder="!loginTypeIdValidation"
						:label="'* ' + $t('fields.loginType')"
					></Dropdown3>
				</v-col>
				<v-col cols="12" class="pb-0 pt-0" v-if="candidateId != null">
					<v-flex xs12 sm12 md12 lg12 class="pb-0 d-flex justify-start">
						<div :class="['text-body-1', 'pt-5', 'mr-4', 'd-inline-block']">
							{{ $t('labels.paymentContract') }}
						</div>
						<v-radio-group v-model="contractType" row mandatory class="d-inline-block">
							<v-radio :label="$t('fields.candidate')" value="candidate"></v-radio>
							<v-radio :label="$t('fields.partner')" value="partner"></v-radio>
						</v-radio-group>
					</v-flex>
				</v-col>
				<v-col cols="12" class="pt-0" v-if="candidateId != null && contractType == 'candidate'">
					<Dropdown2
						v-model="paymentContractOwner"
						:ajax="true"
						:clearable="true"
						:data="'candidate-payment-contract-owners/' + $route.params.id"
						:label="$t('fields.candidateWithPaymentContract')"
					></Dropdown2>
				</v-col>
				<v-col cols="12" class="pt-0" v-if="candidateId != null && contractType == 'partner'">
					<Dropdown2_copy
						v-model="paymentContractOwner"
						:ajax="true"
						:clearable="true"
						:data="'partner-payment-contract-owners/' + $route.params.id"
						:label="$t('fields.partnerWithPaymentContract')"
					></Dropdown2_copy>
				</v-col>

				<v-col cols="12" class="pt-0" v-if="paymentContractOwner != null && contractType == 'candidate'">
					<Dropdown2
						v-model="paymentContract"
						:ajax="true"
						:data="'candidate-payment-contracts/' + paymentContractOwner"
						:label="'* ' + $t('fields.paymentContract')"
						:errorBorder="!paymentContractValidation"
						@item-selected="getPaymentContractItemOfCurrentCourse"
					></Dropdown2>
				</v-col>
				<v-col cols="12" class="pt-0" v-if="paymentContractOwner != null && contractType == 'partner'">
					<Dropdown2_copy
						v-model="paymentContract"
						:ajax="true"
						:clearable="true"
						:data="'partner-payment-contracts/' + paymentContractOwner"
						:label="'* ' + $t('fields.paymentContract')"
						:errorBorder="!paymentContractValidation"
						@item-selected="getPaymentContractItemOfCurrentCourse"
					></Dropdown2_copy>
				</v-col>

				<v-col cols="12" v-if="paymentContractExist == true">
					<Dropdown
						v-model="paymentContractItem"
						:ajax="paymentContractExist"
						:data="'payment-contract-items/' + paymentContract + '/' + $route.params.id"
						:errorBorder="!paymentContractItemValidation"
						:label="'* ' + $t('fields.paymentContractItem')"
					></Dropdown>
				</v-col>
			</v-row>
		</v-container>
		<v-spacer></v-spacer>
		<v-row>
			<v-col cols="12">
				<v-btn class="ma-2" color="primary" variant="text" @click="saveClick"> {{ $t('buttons.save') }} </v-btn>
				<v-btn class="ma-2" color="basicButton" variant="text" @click="cancelClick">
					{{ $t('buttons.cancel') }}
				</v-btn>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import Dropdown from '../../trinkets/Dropdown';
import Dropdown2 from '../../trinkets/Dropdown2';
import Dropdown3 from '../../trinkets/Dropdown3';
import Dropdown2_copy from '../../trinkets/Dropdown2_copy';

export default {
	name: 'ManualRegistration',
	components: { Dropdown, Dropdown2, Dropdown2_copy, Dropdown3 },
	emits: ['close', 'reloadParticipants', 'reloadCandidatesRegistrations'],
	data() {
		return {
			candidateIdValidation: true,
			candidateId: null,
			contractType: 'candidate',
			paymentContract: null,
			paymentContractValidation: true,
			paymentContractItem: null,
			paymentContractItemValidation: true,
			paymentContractExist: false,
			paymentContractOwner: null,
			loginTypeId: null,
			loginTypeIdValidation: true,
		};
	},
	watch: {
		paymentContract(newVal) {
			if (newVal !== null) {
				this.paymentContractExist = true;
			} else {
				this.paymentContractExist = false;
			}
		},
		paymentContractOwner(newVal) {
			if (newVal == null) {
				this.paymentContractExist = false;
				this.paymentContract = null;
				this.paymentContractItem = null;
			}
			if (this.contractType == 'candidate') {
				this.getDefaultPaymentContract();
			}
		},
		contractType() {
			this.paymentContractOwner = null;
		},
	},
	methods: {
		cancelClick() {
			this.candidateId = null;
			this.paymentContract = null;
			this.paymentContractItem = null;
			this.$emit('close');
		},
		getDefaultPaymentContract() {
			let vm = this;
			let payload = {
				candidate_id: this.paymentContractOwner,
				planned_course_id: this.$route.params.id,
			};
			this.$APICall('post', 'default-payment-contract', payload, (data, success) => {
				if (success) {
					if (data.default_payment_contract != null || data.default_payment_contract != 'null') {
						vm.paymentContract = data.default_payment_contract;
						vm.paymentContractItem = data.payment_contract_item_id;
					}
				} else {
					vm.$alert(vm.$t('alerts.basicError'));
				}
			});
		},
		getPaymentContractItemOfCurrentCourse(item) {
			var vm = this;
			this.paymentContractExist = false;
			let payload = {
				payment_contract_id: item.id,
				planned_course_id: this.$route.params.id,
			};
			this.$APICall(
				'post',
				'default-payment-contract-item',
				payload,
				(data, success) => {
					if (success) {
						vm.paymentContractItem = data.default_payment_contract_item_id;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		saveClick() {
			let success = true;

			if (!this.candidateId) {
				success = false;
				this.candidateIdValidation = false;
			} else {
				this.candidateIdValidation = true;
			}

			if (!this.loginTypeId) {
				success = false;
				this.loginTypeIdValidation = false;
			} else {
				this.loginTypeIdValidation = true;
			}

			if (this.paymentContract != null && this.paymentContractItem == null) {
				success = false;
				this.paymentContractItemValidation = false;
			} else {
				this.paymentContractItemValidation = true;
			}

			if (this.paymentContractOwner != null && this.paymentContract == null) {
				success = false;
				this.paymentContractValidation = false;
			} else {
				this.paymentContractValidation = true;
			}

			if (success) {
				let vm = this;
				this.$APICall(
					'post',
					'preregistrations/manual-enrollment/' + this.$route.params.id,
					{
						candidate: this.candidateId,
						payment_contract_item: this.paymentContractItem,
						user_id: this.$myStore.state.user.id,
						planned_course_id: this.$route.params.id,
						login_type_id: this.loginTypeId,
					},
					(data, success) => {
						if (success) {
							if (data == 409) {
								vm.$alert(vm.$t('alerts.candidateAlreadyEnrolled'));
								this.$emit('close');
								return;
							}
							vm.$notify(vm.$t('alerts.basicAdd'));
							vm.$modalBus.$emit('reloadParticipants');
							vm.$modalBus.$emit('reloadPlannedCourse');
							vm.$modalBus.$emit('reloadCandidatesRegistrations');
						} else {
							if (Object.hasOwn(data, 'custom')) {
								vm.$alert(data.message);
								this.$router.go(-1);
							} else {
								vm.$alert(vm.$t('alerts.basicError'));
							}
						}
						this.$emit('close');
					}
				);
			}
		},
	},
};
</script>
